import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApplicationState,
  getSimInfo,
  getSimInfoPending,
  getSimInfoTechnicalError,
} from '../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { SimInfoResource } from '@dch/products-business-logic';
import { GetSimInfo } from '../../../../../store/actions/pricing-plan.actions';
import { getPiiServiceId } from '@dch/ng-usage';
import { filter, map, tap } from 'rxjs/operators';
import { CustomerService, TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-sim-container',
  templateUrl: './sim-container.component.html',
})
export class SimContainerComponent implements OnInit {
  @Output()
  refreshInceptionEventEmitter = new EventEmitter<void>();

  isPending$: Observable<boolean>;
  simData$: Observable<SimInfoResource>;
  hasError$: Observable<boolean>;
  isEbuESimEnabled: boolean;
  isCbuESimEnabled: boolean;
  public isEBU: boolean;
  public isCBU: boolean;
  showESimContent = false;
  constructor(private store: Store<ApplicationState>,private customerService: CustomerService, private translationService: TranslationService) {}

  ngOnInit(): void {
    this.customerService
    .getCustomerAccount()
    .subscribe((customerAccount: any) => {
      this.isEBU = customerAccount?.isEBU();
      this.isCBU = !customerAccount?.isEBU();
    })
    this.isEbuESimEnabled = ((this.translationService.getTranslatedValueFor('products.overview.Ebu.IsESimFlag')??'false') === 'true');
    this.isCbuESimEnabled = ((this.translationService.getTranslatedValueFor('products.overview.Cbu.IsESimFlag')??'false') === 'true');
    if (this.isEBU && this.isEbuESimEnabled || this.isCBU && this.isCbuESimEnabled) {
        this.showESimContent = true;
    }

    this.isPending$ = this.store.select(getSimInfoPending);
    this.simData$ = this.store.select(getSimInfo).pipe(
      filter((simInfo) => simInfo != null),
      tap(() => this.refreshInceptionEventEmitter.emit()),
    );
    this.hasError$ = this.store
      .select(getSimInfoTechnicalError)
      .pipe(map((error) => !!error));
    this.store.dispatch(new GetSimInfo({ msisdn: getPiiServiceId() }));
  }
}
